<template>
  <div v-if="items.length > 0" class="m-related-search-results">
    <RelatedSearchResultsGrid
      :heading="heading"
      :sub-heading="subHeading"
      :search-params="searchParams"
      :aria-heading="ariaHeading"
      :cta-search-label="ctaSearchLabel"
      :cypress-suffix="cypressSuffix"
      :heading-level="headingLevel"
      :items="items"
      :load-more-locale-key="loadMoreLocaleKey"
      :max-items-per-row="maxItemsPerRow"
      :max-items-to-display="maxItemsToDisplay"
      :show-count="showCount"
      :show-top-border="true"
      :total="total"
      :total-label-key="totalLabelKey"
      :use-route="useRoute"
    >
      <template #image="{ item }">
        <ImageAndCaption v-bind="item">
          <template #afterMetadata>
            <SearchCartouches :item="item" />
          </template>
        </ImageAndCaption>
      </template>
    </RelatedSearchResultsGrid>
  </div>
</template>

<script>
import {
  ImageAndCaption,
  RelatedSearchResultsGrid,
  useLocalization
} from "@thegetty-private/getty-ui";
import SearchCartouches from "@/components/atoms/searchCartouches/index.vue";

export default {
  name: "RelatedSearchResults",
  components: {
    ImageAndCaption,
    RelatedSearchResultsGrid,
    SearchCartouches
  },

  props: {
    /**
    /**
     * The Aria label for the search results
     */
    ariaHeading: {
      required: true,
      type: String,
      default: undefined
    },
    /**
     * The heading text to display
     */
    heading: {
      required: false,
      type: String,
      default: () => {
        return undefined;
      }
    },
    /**
     * The Heading Level to Display
     */
    headingLevel: {
      type: Number,
      required: false,
      default: 1
    },
    /**
     * The suffix for the section that gets appended to `m-related-search-results-` to allow for easier testing of this component
     */
    cypressSuffix: {
      required: false,
      type: String,
      default: () => {
        return undefined;
      }
    },
    /**
     * the load more locale key following the translateCount pattern for pluralization
     */
    loadMoreLocaleKey: {
      type: String,
      required: false,
      default: undefined
    },
    /**
     * The search params to feed the search
     */
    searchParams: {
      required: false,
      type: Object,
      default: () => {}
    },
    /**
     * The maximum # of items per row
     */
    maxItemsPerRow: {
      type: Number,
      default: 6
    },
    /**
     * the max # of search results to display on the page (at least initially)
     */
    maxItemsToDisplay: {
      type: Number,
      default: 24
    },
    /**
     * The subheading text
     */
    subHeading: {
      type: String,
      default: undefined
    },
    /**
     * A string specifying the search "display type", i.e., whether "artworks" or "owned works"
     */
    ctaSearchLabel: {
      type: String,
      default: undefined
    },
    /**
     * the total # of results displayed
     */
    total: {
      type: Number,
      required: true
    },
    /**
     * The total # of search results label key
     */
    totalLabelKey: {
      type: String,
      default: "related_search_results.object_count"
    },
    /**
     * For the newer model, we're passing through all of the data instead of the query.
     *
     * replace with "items" in the future
     **/
    items: {
      type: Array,
      default: () => []
    },
    /**
     * Whether or not to display the total count above the grid of search results
     */
    showCount: {
      type: Boolean,
      default: true
    },
    /**
     * If true, go to search, if false, load more
     */
    useRoute: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  }
};
</script>
<style lang="scss">
@import "./index";
</style>
